export const getUserAvatarColor = (userName?: string): 'bg-primary-green-day' | 'bg-red-day' => {
  if (!userName) return 'bg-primary-green-day';

  const hash = Array.from(userName).reduce((acc, char) => (acc * 31 + char.charCodeAt(0)) >>> 0, 0);

  return hash % 2 === 0 ? 'bg-primary-green-day' : 'bg-red-day';
};
